import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { installErrorReporter } from './utils/errorReporter';

// PI-ST9: report uncaught errors / unhandled rejections (flag-gated server-side).
installErrorReporter();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
